import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import colors from "../../../utils/helpers/helperDataset/colors.json";
import { getRandomArbitrary } from "../../../utils/helpers/helperMethods/NumberGenerator";
import Container from "react-bootstrap/Container";
import { Col, Row } from "react-bootstrap";
import IconHome from "../../../styles/icons/IconHome";
import { withUserManagementControllerWrapper } from "../UserManagementControllerWrapper";
import BreadCrumb from "../../../components/organisms/Breadcrumb/BreadCrumb";
import Headline from "../../../components/organisms/Headline/Headline";
import Loader from "../../../components/atoms/Loader/Loader";
import StatusController from "../../../components/organisms/Cards/user-card-controller/StatusController";

const UpdateProfile = ({ ...hocProps }) => {
  const [selectedFile, setSelectedFile] = React.useState();
  const [isFilePicked, setIsFilePicked] = React.useState(false);
  const [editFields, setEditFields] = React.useState({
    name: false,
    jobTitle: false,
    groupType: false,
    status: false,
    mobile: false,
  });
  const [inputValue, setInputValue] = React.useState({
    firstName: "",
    lastName: "",
    jobTitle: "",
    userRole: "",
    mobileNumber: "",
    status: "",
    profilePicture: null,
  });
  let navigate = useNavigate();

  useEffect(() => {
    if (hocProps.selectedUser && hocProps.selectedUser.length > 0) {
      setInputValue({
        ...hocProps.selectedUser[0],
        firstName: hocProps.selectedUser[0].firstName,
        lastName: hocProps.selectedUser[0].lastName,
        jobTitle: hocProps.selectedUser[0].jobTitle,
        userRole: hocProps.selectedUser[0].userRole,
        status: hocProps.selectedUser[0].status,
        mobileNumber: hocProps.selectedUser[0].mobileNumber,
      });
    }
  }, [hocProps.selectedUser]);

  const handleCancel = (e: any) => {
    e.preventDefault();
    setEditFields({
      name: false,
      jobTitle: false,
      groupType: false,
      status: false,
      mobile: false,
    });
    navigate("/user");
  };

  const handleChange = (name: string) => {
    setEditFields((prev) => ({
      ...prev,
      [name]: true,
    }));
  };

  const handleChangeInputValues = (e: any) => {
    const { name, value } = e.target;
    setInputValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (
      editFields.name ||
      editFields.jobTitle ||
      editFields.status ||
      editFields.groupType ||
      editFields.mobile ||
      isFilePicked
    ) {
      hocProps.handleEditUser(inputValue, selectedFile);
    }
    setEditFields({
      name: false,
      jobTitle: false,
      groupType: false,
      status: false,
      mobile: false,
    });
  };

  const deleteUser = (e: any) => {
    e.preventDefault();
    hocProps.handleDeleteUser(inputValue);
  };

  const changeHandler = (event: any) => {
    var selectedFile = event.target.files[0];
    setProfileImage(selectedFile);
    setSelectedFile(selectedFile);
    setIsFilePicked(true);
    setInputValue({
      ...hocProps.selectedUser[0],
      profilePicture: selectedFile,
    });
  };

  const setProfileImage = (selectedFile: any) => {
    if (selectedFile) {
      var reader = new FileReader();
      reader.onload = (e: any) => {
        document
          .getElementById("imgshow")
          ?.setAttribute("src", e.target.result);
      };

      reader.readAsDataURL(selectedFile);
    }
  };

  function handleDisable() {
    if (
      editFields.name ||
      editFields.jobTitle ||
      editFields.status ||
      editFields.groupType ||
      editFields.mobile ||
      isFilePicked
    ) {
      return false;
    } else {
      return true;
    }
  }
  const [color, setColor] = React.useState("");

  useEffect(() => {
    let searchedColor = colors[parseInt(String(getRandomArbitrary(0, 1300)))];
    setColor(searchedColor.hex);
  }, []);
  return (
    <Container fluid className="layout-bar user-profile">
      <BreadCrumb />
      <Headline />
      <div className="box-container">
        {hocProps.selectedUser && hocProps.selectedUser.length > 0 ? (
          <form onSubmit={(e) => handleSubmit(e)}>
            <Row>
              <Col sm={3}>
                <div className="profile-pic">
                  {hocProps.selectedUser[0].profileImage ? (
                    <img
                      src={hocProps.selectedUser[0].profileImage}
                      alt="profile image"
                    />
                  ) : (
                    <div
                      className="manual-profile-pic"
                      style={{ backgroundColor: color }}
                    >
                      {hocProps.selectedUser[0].firstName.charAt(0)}
                      {hocProps.selectedUser[0].lastName.charAt(0)}
                    </div>
                  )}
                  <div className="camera-con">
                    <div className="image-upload">
                      <label htmlFor="file-input">
                        <IconHome
                          breadcrumb={"camera"}
                          activeColor={"#007BFF"}
                        />
                      </label>
                      <img src="#" id="imgshow" />
                      <input
                        id="file-input"
                        type="file"
                        onChange={changeHandler}
                      />
                    </div>
                  </div>
                </div>
                {hocProps.status === "loading" ? <Loader /> : null}
              </Col>
              <Col sm={3}>
                {editFields.name ? (
                  <div className="profile-data-section">
                    <div className="edit-input">
                      <div className="edit-input-label">first name</div>
                      <input
                        className="edit-input-data"
                        name="firstName"
                        defaultValue={hocProps.selectedUser[0].firstName}
                        onChange={(e) => handleChangeInputValues(e)}
                      />
                    </div>
                    <div className="edit-input">
                      <div className="edit-input-label">last name</div>
                      <input
                        className="edit-input-data"
                        name="lastName"
                        defaultValue={hocProps.selectedUser[0].lastName}
                        onChange={(e) => handleChangeInputValues(e)}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="profile-data-section">
                    <div className="title-name">Name</div>
                    <div className="title-details">
                      :&nbsp;&nbsp;{hocProps.selectedUser[0].firstName} &nbsp;
                      {hocProps.selectedUser[0].lastName}
                    </div>
                    <div
                      className="edit-con"
                      onClick={(e) => handleChange("name")}
                    >
                      <IconHome breadcrumb={"editIcon"} activeColor={"null"} />
                    </div>
                  </div>
                )}

                <Row>
                  <Col sm={12}>
                    {editFields.jobTitle ? (
                      <div className="profile-data-section">
                        <div className="title-name">Job Title</div>
                        <div className="edit-input-medium">
                          <input
                            className="edit-input-data"
                            name="jobTitle"
                            defaultValue={hocProps.selectedUser[0].jobTitle}
                            onChange={(e) => handleChangeInputValues(e)}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="profile-data-section">
                        <div className="title-name">Job Title</div>
                        <div className="title-details">
                          :&nbsp;&nbsp;{hocProps.selectedUser[0].jobTitle}
                        </div>
                        <div
                          className="edit-con"
                          onClick={(e) => handleChange("jobTitle")}
                        >
                          <IconHome
                            breadcrumb={"editIcon"}
                            activeColor={"null"}
                          />
                        </div>
                      </div>
                    )}

                    {editFields.groupType ? (
                      <div className="profile-data-section">
                        <div className="title-name">Group Type</div>
                        <div className="edit-input-medium">
                          <select
                            className="edit-input-data"
                            name="groupType"
                            defaultValue={hocProps.selectedUser[0].userRole}
                            onChange={(e) => handleChangeInputValues(e)}
                          >
                            <option value="Admin">Admin</option>
                            <option value="Operator">Operator</option>
                            <option value="Customer">Customer</option>
                          </select>
                        </div>
                      </div>
                    ) : (
                      <div className="profile-data-section">
                        <div className="title-name">Group Type</div>
                        <div className="title-details">
                          :&nbsp;&nbsp;{hocProps.selectedUser[0].userRole}
                        </div>
                        <div
                          className="edit-con"
                          onClick={(e) => handleChange("groupType")}
                        >
                          <IconHome
                            breadcrumb={"editIcon"}
                            activeColor={"null"}
                          />
                        </div>
                      </div>
                    )}

                    <div className="profile-data-section">
                      <div className="title-name">Created Date </div>
                      <div className="title-details">
                        :&nbsp;&nbsp;
                        {hocProps.selectedUser[0].createdDate}
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col sm={3}>
                <div className="profile-data-section">
                  <div className="title-name">Email</div>
                  <div className="title-details">
                    :&nbsp;&nbsp;{hocProps.selectedUser[0].email}
                  </div>
                </div>
                {editFields.mobile ? (
                  <div className="profile-data-section">
                    <div className="title-name">Mobile</div>
                    <div className="edit-input-medium">
                      <input
                        className="edit-input-data"
                        name="mobileNumber"
                        defaultValue={hocProps.selectedUser[0].mobileNumber}
                        onChange={(e) => handleChangeInputValues(e)}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="profile-data-section">
                    <div className="title-name">Mobile</div>
                    <div className="title-details">
                      :&nbsp;&nbsp;{hocProps.selectedUser[0].mobileNumber}
                    </div>
                    <div
                      className="edit-con"
                      onClick={(e) => handleChange("mobile")}
                    >
                      <IconHome breadcrumb={"editIcon"} activeColor={"null"} />
                    </div>
                  </div>
                )}
                <div className="profile-data-section">
                  <div className="title-name">Created By</div>
                  <div className="title-details">
                    :&nbsp;&nbsp;{hocProps.selectedUser[0].createdBy}
                  </div>
                </div>
              </Col>
              <Col sm={3}>
                {editFields.status ? (
                  <div className="profile-data-section">
                    <div className="title-name">Status</div>
                    <div className="edit-input-medium">
                      <select
                        className="edit-input-data"
                        name="status"
                        defaultValue={hocProps.selectedUser[0].status}
                        onChange={(e) => handleChangeInputValues(e)}
                      >
                        {hocProps.userStatusData.map((res: any, key: any) => (
                          <option value={res.id} key={key}>
                            {res.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                ) : (
                  <div className="profile-data-section">
                    <div className="title-name">Status</div>
                    <div className="title-details">
                      :&nbsp;&nbsp;
                      <StatusController
                        state={hocProps.selectedUser[0].status}
                      />
                    </div>
                    <div
                      className="edit-con"
                      onClick={(e) => handleChange("status")}
                    >
                      <IconHome breadcrumb={"editIcon"} activeColor={"null"} />
                    </div>
                  </div>
                )}
              </Col>
            </Row>
            <hr />
            <div className="button-section">
              <div className="btn-line">
                <button className="cancel-btn" onClick={(e) => handleCancel(e)}>
                  Back
                </button>
              </div>
              <div className="btn-line">
                <button
                  className="submit-btn"
                  type={"submit"}
                  disabled={handleDisable()}
                >
                  Update
                </button>
              </div>
            </div>
          </form>
        ) : (
          <Loader />
        )}
      </div>
    </Container>
  );
};

export default withUserManagementControllerWrapper(UpdateProfile);
